import React, { useEffect, useRef, useState } from 'react'
import { makeStyles } from '@mui/styles'
import { Grid, Theme } from '@mui/material';
import "../css/receivefunds.css"
import { Scrollbars } from 'react-custom-scrollbars';




const usBanks = [
  { name: 'Ally Financial', headquarters: 'Detroit, MI' },
  { name: 'American Express', headquarters: 'New York, NY' },
  { name: 'BMO Harris Bank', headquarters: 'Chicago, IL' },
  { name: 'BBVA USA', headquarters: 'Birmingham, AL' },
  { name: 'Bank of America', headquarters: 'Charlotte, NC' },
  { name: 'Barclays US', headquarters: 'Wilmington, DE' },
  { name: 'Capital One', headquarters: 'McLean, VA' },
  { name: 'Charles Schwab Corporation', headquarters: 'San Francisco, CA' },
  { name: 'Citigroup', headquarters: 'New York, NY' },
  { name: 'Citizens Financial Group', headquarters: 'Providence, RI' },
  { name: 'Comerica', headquarters: 'Dallas, TX' },
  { name: 'Fifth Third Bank', headquarters: 'Cincinnati, OH' },
  { name: 'Goldman Sachs', headquarters: 'New York, NY' },
  { name: 'HSBC Bank USA', headquarters: 'New York, NY' },
  { name: 'Huntington Bancshares', headquarters: 'Columbus, OH' },
  { name: 'JPMorgan Chase & Co.', headquarters: 'New York, NY' },
  { name: 'KeyBank', headquarters: 'Cleveland, OH' },
  { name: 'M&T Bank', headquarters: 'Buffalo, NY' },
  { name: 'Morgan Stanley', headquarters: 'New York, NY' },
  { name: 'Northern Trust', headquarters: 'Chicago, IL' },
  { name: 'PNC Financial Services', headquarters: 'Pittsburgh, PA' },
  { name: 'Regions Financial Corporation', headquarters: 'Birmingham, AL' },
  { name: 'Santander Bank', headquarters: 'Boston, MA' },
  { name: 'SunTrust Banks', headquarters: 'Atlanta, GA' },
  { name: 'Synchrony Financial', headquarters: 'Stamford, CT' },
  { name: 'TD Bank, N.A.', headquarters: 'Cherry Hill, NJ' },
  { name: 'Truist Financial', headquarters: 'Charlotte, NC' },
  { name: 'U.S. Bancorp', headquarters: 'Minneapolis, MN' },
  { name: 'Wells Fargo', headquarters: 'San Francisco, CA' },
  { name: 'Zions Bancorporation', headquarters: 'Salt Lake City, UT' }
];

const useStyles = makeStyles((theme: Theme)=>{
    return {
        navIcon: {
            color: '#999 !important',
            fontSize: '1.7rem !important',
            fontWeight: '900 !important'
        },
        logo: {
            transition: 'height 0.4s ease 0s, opacity 0.3s ease 0s',
            margin:'0 auto'
        },
        logoHolder: {
          width: '100%',
          display: 'flex',
          justifyContent:'center',
          alignItems: 'center'
        },
        paragraph: {
          lineHeight: 1.6,
          color: '#555',
          fontSize: '0.978rem',
          fontStyle: 'normal',
          textAlign: 'left',
          fontWeight: '400',
          marginBottom: '30px'
      },
      footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '1rem',
        [theme.breakpoints.down('md')]: {
          padding: '0rem',
        },
      },
      linkButton: {
        color: '#fff !important',
        backgroundColor: '#5d307f',
        borderColor: '#5d307f',
        marginLeft: '10px',
        display: 'inline-block',
        fontWeight: 400,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        userSelect: 'none',
        border: '1px solid transparent',
        padding: '0.375rem 0.75rem',
        fontSize: '1rem',
        lineHeight: 1.5,
        borderRadius: '0.25rem',
        textDecoration: 'none',
        transition: 'all 0.15s ease-in-out',

        "&:hover": {
          color: '#000 !important',
          backgroundColor: '#e37927',
          borderColor: '#e37927',
        },

        [theme.breakpoints.down('sm')]: {
          marginLeft: '0',
          marginTop: '5px',
          display: 'block'
        },
      },
      asideInner: {
        padding: '1rem',
        width: '100%',
        height: '100%',

        [theme.breakpoints.down('md')]: {
          padding: '1rem',
        },
      }
    }
})


interface Props{
    handleBeneficiaryClose3: ()=> void
    lunchSomethingWrong5: ()=> void
    handleEnterPinOpen: ()=> void
}

const AddBeneficiairyPopup: React.FC<Props> = ({handleBeneficiaryClose3, lunchSomethingWrong5, handleEnterPinOpen}) => {
  const classes = useStyles()
  const [benBank, setBenBank] = useState<string>('elit-account')
  const [accountNumber, setAccountNumber] = useState<string>('')
  const [canProceed, setCanProceed] = useState<boolean>(true)

  useEffect(()=>{
    if(accountNumber === ''){
      setCanProceed(true)
    }else{
      setCanProceed(false)
    }
  }, [accountNumber])

  useEffect(()=>{
    if(benBank === 'elit-account'){
      document.getElementById('ben-choose-bank')?.classList.remove('show')
    }else if(benBank === 'other-bank'){
      document.getElementById('ben-choose-bank')?.classList.add('show')
    }
  }, [benBank])


  const handleFormSubmit=(e: React.FormEvent<HTMLFormElement>)=>{
    e.preventDefault()

    handleEnterPinOpen()

  }

  return (
    <div id='ben-beneficiaries-popup' className='sidebar-wrapper-receive-funds'>
        
        <div className='sidebar-receive-funds-beneficiariesmodal-dialog modal-dialog-scrollable'>
            <aside className='sidebar-receive-funds-beneficiaries' style={{maxWidth: '500px'}}>
                
            <div className='funds-ben-header' style={{marginBottom: '35px'}}>
              <h6 className="funds-ben-header-h6">Add New Beneficiaries</h6>
            </div>

            <div style={{overflowY: 'auto', padding: '0.25rem 1.5rem', width: "100%"}}>

              <form onSubmit={(e)=> handleFormSubmit(e)}>
                <div>

                  <div className="add-ben-form-group" style={{marginBottom: '35px'}}>
                    <label>Beneficiary</label>
                    <input name="accountNumber" maxLength={20} className="add-ben-form-group-input" placeholder="Type Account Number" onChange={(e)=> setAccountNumber(e.currentTarget.value)}/>
                  </div>


                  <div className="add-ben-form-group" style={{marginBottom: '35px'}} >
                    <label>Account Type</label>
                    <select name="accountType" className="add-ben-form-group-input" onClick={(e)=> setBenBank(e.currentTarget.value)}>
                      <option value="elit-account">Elit Account</option>
                      <option value="other-bank">Other Banks</option>
                    </select>
                  </div>



                  <div id='ben-choose-bank' className="add-ben-form-group-choose" style={{marginBottom: '35px'}}>
                    <label>Choose Bank</label>
                    <select name="accountType" className="add-ben-form-group-input">
                      {
                        usBanks.map((item: any, index: number)=>{
                          return (
                            <option value={item.name}>{item.name}</option>
                          )
                        })
                      }
                    </select>
                  </div>

                  


                  <div className="dialog-footer mt-3 mb-4" style={{margin: '35px 0'}}>
                    <Grid container>
                      <Grid xs={6}>
                        <button onClick={handleBeneficiaryClose3} className="btn cancel" data-dismiss="modal" type="button" aria-label="Close">CANCEL</button>
                      </Grid>
                      
                      <Grid xs={6}>
                        <button className="btn create-acc" type="submit" disabled={canProceed}>Proceed</button>
                      </Grid>
                    </Grid>
                  </div>

                </div>
              </form>

            </div>

            {/* <div style={{padding: '3rem 0'}}>
              <div className="invalid-flex">

                <svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg"><circle id="gold_circle" cx="27.5" cy="27.5" r="26.5" stroke="#d1a23c" stroke-width="2"></circle><line id="line_red_one" x1="13.1724" y1="39.4716" x2="39.5963" y2="18.8279" stroke="#d1a23c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line><line id="line_red_two" x1="14.4039" y1="18.8277" x2="40.8274" y2="39.4719" stroke="#d1a23c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line>
                </svg>


              </div>
              <div className="invalid-flex-smile">
                <p>Invalid account number. </p>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-5">
                  <button className="btn create-acc" style={{margin: '1.5rem 0'}}>Try Again</button>
                </div>
              </div>
            </div> */}

                
            </aside>
        </div>
    </div>
  )
}

export default AddBeneficiairyPopup



                {/* <svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg"><circle id="gold_circle" cx="27.5" cy="27.5" r="26.5" stroke="#d1a23c" stroke-width="2" style="transition: stroke-dashoffset 1000ms cubic-bezier(0.47, 0, 0.745, 0.715) 0.12s; stroke-dashoffset: 0;"></circle><line id="line_red_one" x1="13.1724" y1="39.4716" x2="39.5963" y2="18.8279" stroke="#d1a23c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="transition: stroke-dashoffset 1000ms cubic-bezier(0.47, 0, 0.745, 0.715) 0.12s; stroke-dashoffset: 0;"></line><line id="line_red_two" x1="14.4039" y1="18.8277" x2="40.8274" y2="39.4719" stroke="#d1a23c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="transition: stroke-dashoffset 1000ms cubic-bezier(0.47, 0, 0.745, 0.715) 0.12s; stroke-dashoffset: 0;"></line>
                </svg> */}